// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__1T3no"};